import Destinations from "./Destinations";

export default Destinations;
